import { useContext, useMemo } from 'react';
import { MslMcpProxyClient } from '../clients/msl-mcp-proxy.js';
import { CustomPageProxiesClientContext, useCustomPageProxiesClient } from './default.js';

export function useMslMcpProxyClient(): MslMcpProxyClient {
  const proxiesClient = useCustomPageProxiesClient();

  return useMemo(
    () => new MslMcpProxyClient(proxiesClient.getAuthenticatedClient()),
    [proxiesClient]
  );
}

export function useOptionalMslMcpProxyClient(): MslMcpProxyClient | null {
  const proxiesClient = useContext(CustomPageProxiesClientContext);

  return useMemo(
    () => (proxiesClient ? new MslMcpProxyClient(proxiesClient.getAuthenticatedClient()) : null),
    [proxiesClient]
  );
}
